var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasGlobalError)?_c('KwAlert',{staticClass:"alert",attrs:{"slot":"panel-alert","type":"error"},slot:"panel-alert"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.i18n('loading_error_cc__notice'))}})]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed6fc2cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KwAppError.vue
// module id = null
// module chunks = 